var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h2',{staticClass:"conTitle"},[_vm._v("标签")]),_vm._v(" "),_c('ul',{staticClass:"tagItem clearfix"},_vm._l((_vm.tagsData),function(item){return _c('li',{on:{"click":function($event){_vm.$goRoute('noteList',{noteListData:item})}}},[_vm._v(_vm._s(item.tagType)),_c('span',[_vm._v("("+_vm._s(item.tagData.length)+")")])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c17c06f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tags.vue
// module id = null
// module chunks = 